import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { createPortal } from "react-dom";
import { XCircle } from "lucide-react";

function Modal({ title, content }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="group inline-flex items-center gap-2 text-blue-900 hover:text-cyan-300 transition-colors"
      >
        <span>{title}</span>
        <span className="group-hover:translate-x-1 transition-transform">
          →
        </span>
      </button>

      {createPortal(
        <AnimatePresence>
          {open && (
            <motion.div
              className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/70 backdrop-blur-md"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setOpen(false)}
            >
              <motion.div
                initial={{
                  opacity: 0,
                  y: 80,
                  scale: 0.95,
                }}
                animate={{
                  opacity: 1,
                  y: 0,
                  scale: 1,
                }}
                exit={{
                  opacity: 0,
                  y: 40,
                  scale: 0.95,
                }}
                transition={{
                  type: "spring",
                  stiffness: 180,
                  damping: 18,
                }}
                onClick={(e) => e.stopPropagation()}
                className="
                  relative
                  w-full
                  max-w-3xl
                  max-h-[90vh]
                  overflow-y-auto
                  rounded-3xl
                  border border-white/10
                  bg-black/10
                  p-8
                  shadow-2xl
                "
              >
                <button
                  onClick={() => setOpen(false)}
                  className="
                    absolute
                    top-4
                    right-4
                    text-red-700
                    hover:text-[#febe10]
                    transition-colors
                  "
                >
                  <XCircle size={36} />
                </button>

                <div className="pr-8">
                  {content}
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>,
        document.body
      )}
    </>
  );
}

export default Modal;